// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount_format}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/* ALL THE SCRIPTS IN THIS FILE ARE MADE BY KROWNTHEMES.COM --- REDISTRIBUTION IS NOT ALLOWED! */

$(window).bind("pageshow", function(event) {
    if (event.originalEvent.persisted) {
        window.location.reload();
    }
});

$.ajaxSetup({ cache: false });

// CONTINUE WITH EVERYTHING ELSE

window.blockStickyHeader = false;

(function($) {
    // Check privacy
    $(".check-privacy").on("click", function() {
        const idC = $(this).attr("data-id");
        const input = $("#" + idC);
        if (input.is(":checked")) {
            return true;
        } else {
            var error = input.attr("data-error");
            if(error == undefined){
                if (input.parent().find(".error").length == 0) {
                    var err = input.attr("data-error");
                    input.parent().append('<p class="error">' + err + "</p>");
                }
            }
            else{
                input.parent().parent().find(".error").css('display','block');
            }
        }
        return false;
    });

    // tab navigation
    $("a:not(.ach), button, span, input")
        .on("focus", function(e) {
            $(this).addClass("hover");
        })
        .on("blur", function(e) {
            $(this).removeClass("hover");
        });

    // hover
    $(document).keyup(function(e) {
        if (e.keyCode === 27) {
            $(".site-close-handle").trigger("click");
        }
    });
    window.CUBER = {
        // PRODUCT
        Product: {
            $productGallery: null,
            $productGalleryItem: null,
            $productGalleryIndex: null,

            $productCarousel: null,
            $productCarouselImgs: null,
            productFlkty: null,

            $productStuff: null,
            productStuffMove: false,


            mount: function($product) {
                var productIsDisabled = false;
                // GO TO RELATED BUTTON
                if ($product.find(".go-related").length > 0) {
                    $product.find(".go-related").on("click", function() {
                        TweenLite.to(window, 1, {
                            scrollTo: $(this).attr("href")
                        });
                        return false;
                    });
                }

                var _this = {};
                $product.data("po", _this);

                // Inizializza dati prodotto
                this.initVariantForm($product, productIsDisabled);
                // Inizializza qty button
                this.initQtyButton($product);

                if (
                    $product.find(".product--add-to-cart-form").length > 0 &&
                    !$("html").hasClass("ie9")
                ) {
                    let $form = $product.find(
                            ".product--add-to-cart-form form"
                        ),
                        $submitText = $form.find(".add-to-cart-text"),
                        $submitButton = $form.find('button[type="submit"]');

                    if ($form.attr("action").indexOf(".js") < 0) {
                        $form.attr("action", $form.attr("action") + ".js");
                    }

                    $form.submit(function(e) {
                        e.preventDefault();
                        // Loading
                        var oldText = $submitText.html();
                        $submitText.html(
                            '<span class="preloader"><span>.</span><span>.</span><span>.</span></span>'
                        );
                        $submitButton.css("pointer-events", "none");

                        //
                        // Dati per facebook
                        var itemName = $product.find(".product-title").text(),
                            itemPrice = $product
                                .find(".product-price")
                                .attr("data-price"),
                            itemCurrency = $(
                                'meta[itemprop="priceCurrency"]'
                            ).attr("content"),
                            itemId = $product
                                .find(".product--section")
                                .data("id");

                        // Verifica se il prodotto è già presente nel carrello e in caso
                        // Cambia l'url della chiamata impostando la quantità corretta
                        const idVar  = $product.find(".product-selected").val();
                        const selDom = '.cart-item[data-variant="'+idVar+'"]';
                        let formData = $form.serialize();
                        let formUrl = "/cart/add.js";
                        if($(selDom).length>0){
                            let qtySel = parseInt($form.find('input[name="quantity"]').val());
                            formData   = "updates["+idVar+"]="+(parseInt($(selDom).attr('data-qty'))+qtySel);
                            formUrl = "/cart/update.js";
                        }

                        $.ajax({
                            type: $form.prop("method"),
                            url: formUrl,
                            data: formData,
                            dataType: "json",
                            success: function() {
                                setTimeout(function() {
                                    $submitText.html(oldText);
                                    $submitButton.css("pointer-events", "all");
                                }, 500);


                                /*if (typeof fbq !== "undefined") {
                                  console.log("ItemId " + itemId);
                                    fbq("track", "AddToCart", {
                                        content_name: itemName,
                                        content_ids: [itemId],
                                        content_type: "product_group",
                                        value: itemPrice,
                                        currency: itemCurrency
                                    });
                                }*/
                                window.CUBER.SiteCart.refresh(function(){
                                      // Ripristono testo submit
                                        setTimeout(function() {
                                            $submitText.html(oldText);
                                            $submitButton.css(
                                                "pointer-events",
                                                "all"
                                            );
                                        }, 500);
                                });
                            },

                            error: function(data) {
                                alert(data.responseJSON.description);

                                setTimeout(function() {
                                    $submitText.html(oldText);
                                    $submitButton.css("pointer-events", "all");
                                }, 100);
                            }
                        });
                    });
                }
            },

            centerStructure: function(){
                if($('.center-box-full').length==0) return;

                var dom = $('.center-box-full');
                if(dom.find('.box-square').length > 4) return;
                let nstart = Math.floor(dom.find('.empty-box').length / 2);
                let i = 0;
                dom.find('.empty-box').each(function(){
                    if(++i>nstart)
                        return;
                    dom.prepend($(this));
                })
            },

            // Check stato pulsanti quantità
            checkQtyButton: function($product) {
                if ($product.find(".qty-button").length == 0) {
                    return;
                }
                let $productQty = $product.find(".quantity-selector-input");

                if (parseInt($productQty.val()) - 1 < 1) {
                    $product.find(".qty-minus").addClass("disable");
                }

                if (
                    parseInt($productQty.val()) + 1 >
                    parseInt($productQty.attr("max"))
                ) {
                    $product.find(".qty-plus").addClass("disable");
                }
            },

            // Handle click pulsanti quantità
            initQtyButton: function($product) {
                if ($product.find(".qty-button").length == 0) {
                    return;
                }
                let $productQty = $product.find(".quantity-selector-input");
                $product.find(".qty-minus").on("click", function() {
                    let $btn = $(this);
                    if ($btn.hasClass("disable")) {
                        return false;
                    }
                    var $newQty = parseInt($productQty.val()) - 1;
                    $productQty.val($newQty);
                    if ($newQty == 1) {
                        $btn.addClass("disable");
                    }
                    $product.find(".qty-plus").removeClass("disable");
                    return false;
                });

                $product.find(".qty-plus").on("click", function() {
                    let $btn = $(this);
                    if ($btn.hasClass("disable")) {
                        return false;
                    }
                    var $newQty = parseInt($productQty.val()) + 1;
                    $productQty.val($newQty);
                    $product.find(".qty-minus").removeClass("disable");
                    return false;
                });
            },

            initVariantForm: function($product, pdisabled) {
                var productSingleObject =
                    window.products[$product.attr("data-id")];
                if (productSingleObject === undefined) return;

                // Handle click sulle varianti visualizzate come liste
                this.initListVariant($product);

                $product.find("form .product-variants-input").on(
                    "change",
                    function(e) {
                        this._initProductVariantChange(
                            false,
                            productSingleObject,
                            $product
                        );
                    }.bind(this)
                );

                this._initProductVariantChange(
                    true,
                    productSingleObject,
                    $product
                );

                if (
                    productSingleObject.variants.length == 1 &&
                    productSingleObject.variants[0].title.indexOf("Default") >=
                        0
                ) {
                    $product.find(".product-variant").hide();
                }
            },

            /**
             * Cambio valore misure
             * @param {*} $product
             */
            initListVariant: function($product) {
                $product.find(".list-variant").each(function() {
                    let $option = $(this);
                    $option.find(".option-value").on("click", function() {
                        let self = $(this);
                        if (self.hasClass("selected")) return;
       $('#slick-slide-control00').trigger("click");
                        $option.find(".option-value").removeClass("selected");
                        self.addClass("selected");
                        $option
                            .find(".product-variants-input")
                            .val(self.attr("data-value"));
                        $option
                            .find(".product-variants-input")
                            .trigger("change");

                        if (self.hasClass("show-value")) {
                            $option
                                .find(".value")
                                .html(self.attr("data-label"));
                        }
                        return false;
                    });
                });
            },

            /** Crea l'array con la lista di opzioni selezionate */
            _getProductOptions: function($product) {
                if ($product.find("form .product-variants-input").length == 0)
                    return null;

                let optionArray = [];
                $product.find("form .product-variants-input").each(function() {
                    if ($(this).hasClass("is-select")) {
                        optionArray.push(
                            $(this)
                                .find(":selected")
                                .val()
                        );
                    } else {
                        optionArray.push($(this).val());
                    }
                });
                return optionArray;
            },

            _initProductVariantChange: function(
                firstTime,
                productSingleObject,
                $product
            ) {
                let variant = null;
                const options = this._getProductOptions($product);

                // Cerca la variante con le opzioni selezionate
                productSingleObject.variants.forEach(function(el) {
                    if ($(el)[0].options.equals(options)) {
                        variant = $(el)[0];
                    }
                });

                this._productSelectCallback(
                    variant,
                    $product,
                    productSingleObject
                );
                if (
                    !firstTime &&
                    $product.find(".product-selected option").length > 1 &&
                    !$("body").hasClass("template-index")
                ) {
                    this._updateProductVariantState(variant);
                }
            },

            /** Aggiorna indirizzo pagina con la variante selezionata */
            _updateProductVariantState: function(variant) {
                if (!history.pushState || !variant) {
                    return;
                }
                var newurl =
                    window.location.protocol +
                    "//" +
                    window.location.host +
                    window.location.pathname +
                    "?variant=" +
                    variant.id;
                window.history.replaceState({ path: newurl }, "", newurl);
            },

            _productSelectCallback: function(variant, $product) {
                let $addToCart = $product.find(".product--add-to-cart-form"),
                    $addToCartButton = $addToCart.find('button[type="submit"]'),
                    $productPrice = $product.find(".product-price"),
                    $comparePrice = $product.find(".compare-price"),
                    $quantityElements = $product.find(
                        ".quantity-selector-input"
                    ),
                    $quantityElementsHolder = $product.find(
                        ".quantity-selector"
                    ),
                    $addToCartText = $product.find(".add-to-cart-text"),
                    $productGallery = $product.find(".box-main-image");

                if (variant) {
                    // Set cart value id
                    $product
                        .find(".product-selected")
                        .find('option[value="' + variant.id + '"]')
                        .prop("selected", true);

                    //  Change picture
                    if (variant.featured_image != null) {
                        $productGallery.find("img").removeClass("show");
                        $productGallery
                            .find(
                                "img[data-id='" +
                                    variant.featured_image.id +
                                    "']"
                            )
                            .addClass("show");
                    }

                    // Edit cart buttons based on stock
                    var $variantQuantity = $product.find(".variant-quantity");
                    if (variant.available) {
                        $quantityElements.prop("max", 999);
                        $addToCartButton
                            .removeClass("disabled")
                            .prop("disabled", false);
                        $addToCartText.text(
                            $("body").hasClass("template-product-pre-order")
                                ? $addToCartText.data("text")
                                : window.product_words_add_to_cart_button
                        );
                        $variantQuantity.text(
                            $("body").hasClass("template-product-pre-order")
                                ? $variantQuantity.data("text")
                                : ""
                        );
                        $quantityElements.show();
                        if ($quantityElementsHolder != null) {
                            $quantityElementsHolder.show();
                        }
                    } else {
                        $variantQuantity.text(window.product_words_no_products);
                        $addToCartButton
                            .addClass("disabled")
                            .prop("disabled", true);
                        $addToCartText.text(
                            window.product_words_sold_out_variant
                        );
                        $quantityElements.hide();
                        if ($quantityElementsHolder != null) {
                            $quantityElementsHolder.hide();
                        }
                    }
                    this.checkQtyButton($product);

                    // Update price

                    $productPrice.html(
                        Shopify.formatMoney(
                            variant.price,
                            window.shop_money_format
                        )
                    );
                    $productPrice.attr("data-price", variant.price / 100);
                    if (variant.compare_at_price > variant.price) {
                        $comparePrice
                            .html(
                                Shopify.formatMoney(
                                    variant.compare_at_price,
                                    window.shop_money_format
                                )
                            )
                            .show();
                        $comparePrice.show();
                    } else {
                        $comparePrice.hide();
                    }

                    // Update sku

                    if ($product.find(".variant-sku").length > 0) {
                        if (variant) {
                            $product.find(".variant-sku").text(variant.sku);
                        } else {
                            $product.find(".variant-sku").empty();
                        }
                    }
                } else {
                    // Disable variant completely

                    $addToCartButton
                        .addClass("disabled")
                        .prop("disabled", true);
                    $addToCartText.text(
                        window.product_words_unavailable_variant
                    );
                    $quantityElements.hide();
                    if ($quantityElementsHolder != null) {
                        $quantityElementsHolder.hide();
                    }
                }

                this.checkQtyButton($product);
            },

            _advancedOptionsSelector: function($product, productJson) {
                var om = {};
                $product.data("om", om);
                var forceMutation = false;
                var $addToCartForm = $product.find(
                    ".product--add-to-cart-form"
                );
                if (window.MutationObserver && $addToCartForm.length) {
                    if (
                        typeof observer === "object" &&
                        typeof observer.disconnect === "function"
                    ) {
                        observer.disconnect();
                    }
                    var config = { childList: true, subtree: true };
                    var observer = new MutationObserver(function() {
                        Shopify.linkOptionSelectors(productJson, $product);
                        observer.disconnect();
                    });
                    if (forceMutation) {
                        Shopify.linkOptionSelectors(productJson, $product);
                    }
                    observer.observe($addToCartForm[0], config);
                }
            },

            unmount: function($product) {
                var po = $product.data("po");
                $(window).off("scroll.product-gallery");
                $(window).off("resize.position-product-zoom");
                po.$productCarousel.off("scroll.flickity");
                po.$productCarousel.off("select.flickity");
                po.productFlkty.destroy();
                $("#product-zoom").off("click");
            }
        },
        Gallery:{
            slick: false,
            dom:null,
            canSlick:false,
            mount:function(){
                if($('#mobile-slider').find('.gallery-item').length <2){
                    return ;
                }
                this.check();
                $(window).resize(function(){
                    window.CUBER.Gallery.check();
                })
            },
            check:function(){
                var mustSlick = $(window).width()<768;
                if(this.slick==mustSlick) return;
                if(mustSlick){
                     $('#mobile-slider').slick({
                        dots: true,
                        slidesToShow: 1,
                        arrows:false
                    });


                              $('#mobile-slider').on('swipe', function(event, slick, currentSlide, nextSlide){


				var currentSlide = $('#mobile-slider').slick('slickCurrentSlide');

              if (currentSlide == 0) {
         			$('#title-product').addClass("product-title-mobile").css("color", "#535353");
        		$('#product-price-content').addClass("product-price-mobile").css("color", "#535353");
        		$('#scroll-to-accessories').css("color", "#535353");
                $('#scroll-to-accessories').css("font-weight","100");
                $('#sale-price').css("color","#535353");

              } else {
      			$('#title-product').addClass("product-title-mobile").css("color", "white");
        		$('#product-price-content').addClass("product-price-mobile").css("color", "white");
        		$('#scroll-to-accessories').css("color", "white");
                $('#scroll-to-accessories').css("font-weight","600");
                  $('#sale-price').css("color","white");

              }

			});
                }
                else{
                    if(this.slick){
                        $('#mobile-slider').slick("unslick");
                    }




                }
                this.slick = mustSlick;

            }
        },
        PopupProduct: {
            lnk:null,
            tm:null,
            checkmessage: function(){
                var find = false;
                $('.main-product .product-selected option').each(function(){
                    var itm = $(this);
                    // Id variante
                    var idv = $(this).attr('value');
                    if($('.cart-item[data-variant="'+idv+'"]').length > 0){
                        find = true;
                        var txt = itm.html();
                        $('.popup-product-cart .popup-message').each(function(){
                            var mess = $(this).attr('data-message');
                            $(this).html(mess.replace("[VARIANT]",txt));
                        });
                    }
                });
                if(!find){
                    $('.popup-product-cart .popup-message').html("");
                }
            },

            mount: function() {
                var self = this;
                $("body").append($(".popup-product-cart"));


                $("a.product-item").on("click", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    self.checkmessage();
                    self.lnk = $(this);
                    self.openProduct();
                    return false;
                });

                $(".popup-product-cart .close-popup").on("click", function() {
                    self.tm.reverse();

                    return false;
                });
            },

            getPopup:function(){
                let id = "#pr" + this.lnk.attr("data-id");
                return $(id);
            },
            openProduct:function(){
                if($(window).width()<768){
                    this.openMobileProduct();
                }
                else{
                    this.openDesktopProduct();
                }
            },

            openMobileProduct:function(){
                var popup = this.getPopup();
                this.tm = new TimelineLite();
                // mostra popup
                popup.css("display","block");
              $(".product-price").css("color","white");
              $(".compare-price").addClass("popup-sale-price");

                $(".product-price").css("position","unset");
                this.tm.to(popup,0.4,{opacity:1,onReverseComplete:function(){
                    popup.css("display","none");
                       $(".product-price").css("color","#535353");
                $(".product-price").css("position","absolute");
                    $(".compare-price").removeClass("popup-sale-price");

                }});

            },


            openDesktopProduct:function() {
                var popup = this.getPopup();
                var img   = this.lnk.find('.primary-image');

                // Posizione/dimensione elemento selezionato
                var topSelected = this.lnk.offset().top - $(window).scrollTop(),
                leftSelected    = this.lnk.offset().left,
                widthSelected   = img.width(),
                heightSelected  = img.height(),
                windowWidth = $(window).width(),
                windowHeight = $(window).height();

                // Calcola dimensione finale popup
                var finalWidth = windowWidth*0.8;
                var finalHeight = (finalWidth/2);
                if(finalHeight > windowHeight *0.8){
                    finalHeight = windowHeight *0.8;
                    finalWidth = finalHeight*2;
                }

                // Posizione finale
                var finalLeft = (windowWidth - finalWidth)/2,
                    finalTop   = (windowHeight - finalHeight)/2,
                    middleLeft = (windowHeight - finalHeight)/2;

                // Inizializzo gli elementi prima dell'animazione
                popup.css({'display':'block'});
               $(".compare-price").addClass("popup-sale-price");
                var cnt  = popup.find('.popup-product-content');
                var info = popup.find('.col-info');
                info.css('opacity',0);
                cnt.find('.col-gallery').css('max-width',windowWidth+"px");
                cnt.css({
                    top:    topSelected+'px',
                    left:   leftSelected+"px",
                    width:  widthSelected+"px",
                    height: heightSelected+"px"
                })

                // Crea animazione
                this.tm = new TimelineLite();
                // mostra popup
                this.tm.to(popup,0.3,{opacity:1,onReverseComplete:function(){
                    popup.css("display","none");
                }});

                this.tm.to(cnt,0.7,{top:finalTop,left:middleLeft,height:finalHeight,width:finalHeight,ease: Elastic.easeOut.config(1, 0.75)},"-=0.2");
                this.tm.to(cnt,0.4,{
                    left:finalLeft,
                    width:finalWidth,
                    onStart:function(){
                        cnt.find('.col-gallery').css('max-width',finalHeight+"px");
                    },
                    onReverseComplete:function(){
                        cnt.find('.col-gallery').css('max-width',windowWidth+"px");
                    }
                });

                this.tm.to(info,0.3,{
                    opacity:1,
                    onStart:function(){
                        info.css({'display':'block'})
                    },
                    onReverseComplete:function(){
                        info.css({'display':'none'})
                    }
                })
            }
        },

        SiteCart: {
            $siteCart: null,

            mount: function() {
                this.$siteCart = $("#site-cart");

                $(".site-cart-handle a").on(
                    "click",
                    function() {
                        this.open();
                        return false;
                    }.bind(this)
                );

                $(".site-cart-close-handle").on(
                    "click",
                    function() {
                        this.close();
                        return false;
                    }.bind(this)
                );

                this.$siteCart.find('.cart-items').on("click",function(e){
                    e.stopPropagation();
                });

                this.$siteCart.on("click",function(){
                    this.close();
                }.bind(this));

                this.initItems();
            },

            open: function() {
                this.$siteCart.css("display", "block");
                TweenLite.to(this.$siteCart, 0.3, { opacity: "1" });
                let i = 0;
                this.$siteCart.find(".cart-section").each(function() {
                    let t = $(this);
                    TweenLite.to(t, 0.3, { x: "0%", delay: 0.1 + i * 0.05 });
                    i++;
                });
            },

            close: function() {
                let i = 0;
                var self = this;
                this.$siteCart.find(".cart-section").each(function() {
                    let t = $(this);
                    TweenLite.to(t, 0.3, { x: "100%", delay: 0 + i * 0.05 });
                    i++;
                });
                TweenLite.to(this.$siteCart, 0.3, {
                    opacity: "0",
                    delay: i * 0.05,
                    onComplete: function() {
                        self.$siteCart.css("display", "none");
                    }
                });
            },

            refresh: function(onFinish){
                $.ajax({
                    url: routes.cart_url,
                    success: function(data) {

                        // Aggiorno prodotti
                        $(".cart-side-products").html(
                            $(data)
                                .find(".cart-side-products")
                                .html()
                        );
                        // Aggiorno totale
                        $("#CartTotal").html(
                            $(data)
                                .find("#CartTotal")
                                .html()
                        );

                        window.CUBER.SiteCart.initItems();

                        let totalQty = 0;
                        $("#site-cart .qty").each(
                            function() {
                                totalQty += parseInt(
                                    $(this).val()
                                );
                            }
                        );

                        $(".cart-menu .count").html(totalQty);

                        if (totalQty == 1) {
                            $("#site-cart .subtitle").html(
                                $("#site-cart .subtitle")
                                    .data("added-singular")
                                    .replace(
                                        /{{ count }}|count|{{count}}/g,
                                        totalQty
                                    )
                            );
                        } else {
                            $("#site-cart .subtitle").html(
                                $("#site-cart .subtitle")
                                    .data("added-plural")
                                    .replace(
                                        /{{ count }}|count|{{count}}/g,
                                        totalQty
                                    )
                            );
                        }

                        $(".site-cart-handle a").trigger(
                            "click"
                        );
                        if(typeof onFinish==="function"){
                            onFinish();
                        }
                    }
                });
            },

            initItems: function(){
                var self = this;
                this.$siteCart.find('.remove-item').addClass("is_ajax");
                this.$siteCart.find('.cart-modify').addClass("is_ajax");
                this.$siteCart.find('.cart-item').each(function(){
                    self.handleEvent($(this));
               });
            },

            handleEvent: function(itm){
                var self = this;
                var qty = itm.find('.qty');
                itm.find('.qty-button').on("click",function(){
                    var step = $(this).hasClass('qty-plus')?1:-1;
                    var newQty = parseInt(qty.val())+step;
                    if(newQty>0) qty.val(newQty);
                    return false;
                });

                itm.find('.remove-item').on("click",function(){
                    if($(this).hasClass("is_ajax")){
                        var id = $(this).attr('data-id');
                        self.updateVariant(id,0,true);
                        return false;
                    }
                    return true;
                });

                itm.find('.cart-modify').on("click",function(){
                    var id = $(this).attr('data-id');
                    var isAjax = $(this).hasClass("is_ajax");
                    self.updateVariant(id,qty.val(),isAjax);
                    return false;
                });
            },

            updateVariant: function(id,qty,ajax){
                this.$siteCart.find('div[data-variant="'+id+'"]').addClass("updating");
                var data = "updates["+id+"]="+qty;
                $.ajax({
                    method:"POST",
                    data:data,
                    dataType: "json",
                    url:"/cart/update.js",
                    success:function(){
                        if(!ajax) window.location = routes.cart_url;
                        else      window.CUBER.SiteCart.refresh();
                    }
                });
            },


 


        },

        PageCart: {
            select:null,
            wrapInput:null,
            haveSend:false,
            position:"d",
            isItaly:function(){
                return this.select.val()=="Italy";
            },

            isEmpty:function(){
                return this.select.val()=="";
            },

            checkWrap:function(){
                this.wrapInput.css("display",this.isItaly()?"block":"none");
            },
            isCodFiscale: function(v){
                var ex = new RegExp("^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$");
                return ex.test(v);
            },

            checkForm:function(){
                try{
                    var value = $('.codfiscale').val();
                    if(this.isCodFiscale(value)){
                        return true;
                    }
                }
                catch(e){}
                $('.error-codicefiscale').css('display','block');
                return false;
            },

            checkPosition:function(){
                var newPos = $(window).width()<768?"m":"d";
                if(this.position == newPos) return;
                this.position = newPos;
                var form = $("#cartform");
                var wrp  = newPos=="d"?$('#formdesktop'):$('#formmobile');
                wrp.append(form);
            },


            mount:function(){
                this.checkPosition();
                $(window).resize(function(){
                    this.checkPosition();
                }.bind(this));


                this.select    = $(".wrapfiscalcode select");
                this.wrapInput = $(".wrapinput");

                // Check cambiamenti selezione paese
                this.select.on("change",function(){
                    this.checkWrap();

                }.bind(this))
                // inizializza select
                if(this.select.attr("data-value")!=""){
                    this.select.val(this.select.attr("data-value"));
                    this.checkWrap();
                }

                // Check cambiamenti codice fiscale
                $(".codfiscale").on("keyup",function(){
                    if(this.haveSend){
                        this.checkForm();
                    }
                }.bind(this));
                // check submit form
                $('.checkout-button').on("click",function(){
                    this.haveSend = true;
                    if(this.isEmpty())
                        return false;

                    if(this.isItaly()){
                        return this.checkForm();
                    }
                    return true;
                }.bind(this));


            }
        },

        // MAIN
        Main: {
            $searchForm: null,
            $searchResults: null,
            $searchPreloader: null,
            $searchPagination: null,

            $body: null,
            $siteHeader: null,
            $siteFooter: null,

            $siteBoxes: null,

            _mountScrollMovers: function(props) {
                var $parent = props["parent"],
                    parentOutOfFocus = false;

                setTimeout(function() {
                    props["items"].removeClass("out-with-you");
                }, 1000);
                props["items"].addClass("animate-owy");

                $(window).on(
                    "scroll.scroll-movers",
                    function() {
                        /*if ( ! parentOutOfFocus && $(window).scrollTop() + $(window).height() < $parent.offset().top ) {

						// before element
						props['items'].addClass('out-with-you');
						parentOutOfFocus = true;

					} else *if ( ! parentOutOfFocus && $(window).scrollTop() + $(window).height() > $parent.offset().top + $parent.height() ) {

						// after element
						props['items'].addClass('out-with-you');
						parentOutOfFocus = true;

					} else if ( parentOutOfFocus && $(window).scrollTop() + $(window).height() <= $parent.offset().top + $parent.height() ) {

						// within element
						parentOutOfFocus = false;
						props['items'].removeClass('out-with-you');

					}
					*/
                    }.bind(this)
                );
            },

            _mobileSharingInit: function() {
                $(".touchevents .site-sharing .icon").on("touchstart", function(
                    e
                ) {
                    e.preventDefault();
                    var $parent = $(this).parent();

                    if ($parent.hasClass("hover")) {
                        $parent.removeClass("hover");
                    } else {
                        $parent.addClass("hover");
                    }
                });

                $(".touchevents .site-sharing a").on("touchstart", function(e) {
                    $(this)
                        .parent()
                        .removeClass("hover");
                });
            },

            _resizeEverything: function() {
                this.$body.css("paddingTop", this.$siteHeader.outerHeight());

                if (this.$body.hasClass("template-index")) {
                    if ($("#fix-me-header").css("display") == "block") {
                        if ($(".mount-slideshow").children("div").length > 0) {
                            $("#shopify-section-home_slideshow").css(
                                "marginTop",
                                -this.$siteHeader.outerHeight()
                            );
                            $(".fix-me-with-margin").css(
                                "marginTop",
                                this.$siteHeader.outerHeight()
                            );
                        } else {
                            $(
                                ".index-section:first-child .fix-me-with-margin"
                            ).css("marginTop", -this.$siteHeader.outerHeight());
                            $(
                                ".index-section:first-child .fix-me-with-height"
                            ).css(
                                "height",
                                $(window).height() -
                                    this.$siteHeader.outerHeight()
                            );
                        }
                    } else {
                        if ($(".mount-slideshow").children("div").length > 0) {
                            $("#shopify-section-home_slideshow").css(
                                "marginTop",
                                "0"
                            );
                            $(
                                ".slideshow-item:first-child .site-box-content"
                            ).css("marginTop", "0");
                        }
                    }
                } else {
                    if ($("#fix-me-header").css("display") == "block") {
                        $(".fix-me-with-margin").each(
                            function(key, elm) {
                                if ($(elm).outerHeight() < $(window).height()) {
                                    $(elm).css(
                                        "marginTop",
                                        -this.$siteHeader.outerHeight()
                                    );
                                } else {
                                    $(elm).css("marginTop", "0");
                                }
                            }.bind(this)
                        );

                        $(".fix-me-with-height-hard").css({
                            height:
                                $(window).height() -
                                this.$siteHeader.outerHeight(),
                            "min-height":
                                $(window).height() -
                                this.$siteHeader.outerHeight()
                        });
                        $(".fix-me-with-height").css({
                            "min-height":
                                $(window).height() -
                                this.$siteHeader.outerHeight()
                        });
                    } else {
                        $(".fix-me-with-margin").css("marginTop", "0");
                        $(".fix-me-with-height, .fix-me-with-height-hard").attr(
                            "style",
                            ""
                        );
                    }
                }

                if ($(".mount-product").length > 0) {
                    $(".mount-product").each(
                        function(key, elm) {
                            if (window.CuberFixGalleryItem) {
                                $(elm)
                                    .find(".gallery-item")
                                    .css(
                                        "height",
                                        ($(window).height() -
                                            this.$siteHeader.outerHeight()) *
                                            0.8
                                    );
                            }

                            $(elm)
                                .find(".product--section")
                                .removeClass("sticky-because");
                            if (
                                $(elm)
                                    .find(".site-box.box__product-gallery")
                                    .css("content") != '"fix-me-also"' &&
                                $(elm)
                                    .find(".site-box.box__product-gallery")
                                    .height() <
                                    $(elm)
                                        .find(".site-box.box__product-content")
                                        .height()
                            ) {
                                $(elm)
                                    .find(".product--section")
                                    .addClass("sticky-because");
                            }
                        }.bind(this)
                    );

                    /*if ( $('.site-box.box__product-gallery').css('content') == '"fix-me-also"' ) {
						$('.site-box.box__product-gallery').css('height', $(window).height() - this.$siteHeader.outerHeight());
					}*/
                }

                $(".site-header.desktop-view--classic .submenu").css(
                    "top",
                    $(".site-header").outerHeight()
                );

                if ($("#site-menu-handle").css("opacity") == "1") {
                    $(".site-nav.style--sidebar a, #site-menu-handle").attr(
                        "tabIndex",
                        0
                    );
                } else {
                    $(".site-nav.style--sidebar a, #site-menu-handle").attr(
                        "tabIndex",
                        -1
                    );
                }
            },

            _animateEverything: function(firstAnimation) {
                var i = 0;

                this.$siteBoxes.each(function() {
                    var vp = 0;

                    /*if ( ! firstAnimation ) {

						if ( ( $(this).height() - 100 ) > $(window).height() / 2 ) {
							vp = 0;
						} else {
							vp = 0;
						}
					}*/

                    if (
                        !$(this).hasClass("active") &&
                        $(window).scrollTop() + $(window).height() >
                            $(this).offset().top + vp
                    ) {
                        i++;

                        setTimeout(
                            function() {
                                $(this).addClass("active");
                            }.bind(this),
                            100 * i
                        );
                    }
                });

                if (
                    !this.$siteFooter.hasClass("active") &&
                    $(window).scrollTop() + $(window).height() >
                        this.$siteFooter.offset().top + 150
                ) {
                    this.$siteFooter.addClass("active");
                    this.$siteFooter.find(".site-box").addClass("active");
                }
            },

            mount: function() {
                $(".rte").fitVids();

                this.$siteBoxes = $(".site-box:not(.footer-box)");
                this.$siteFooter = $(".site-footer");

                if (!$("body").hasClass("ie9")) {
                    this._animateEverything(true);
                    $(window).on(
                        "scroll.fade-animation",
                        function(e) {
                            this._animateEverything(false);
                        }.bind(this)
                    );
                }

                $("html.no-touchevents a[href]").each(function() {
                    $(this).on("click", function(e) {
                        if (
                            e.ctrlKey ||
                            e.metaKey ||
                            $(this).attr("target") == "_blank" ||
                            $(this).hasClass("video-lightbox") ||
                            $(this).hasClass("lightbox") ||
                            $(this).hasClass("has-popup") ||
                            $(this).hasClass("block-fade") ||
                            $(this).attr("href") == "" ||
                            $(this)
                                .attr("href")
                                .indexOf("#") >= 0
                        ) {
                            //
                        } else {
                            $(this).off("click");

                            $("body").fadeOut(200);
                            setTimeout(
                                function() {
                                    document.location.href = $(this).attr(
                                        "href"
                                    );
                                }.bind(this),
                                200
                            );
                            e.preventDefault();
                        }
                    });
                });

                //

                this.$body = $("body");
                this.$siteHeader = $("#site-header");

                $(window).on(
                    "resize",
                    window.debounce(
                        function() {
                            this._resizeEverything();
                        }.bind(this),
                        300
                    )
                );
                this._resizeEverything();

                setTimeout(
                    function() {
                        this._resizeEverything();
                    }.bind(this),
                    1000
                );

                // tabs & toggles

                if ($(".krown-tabs").data("design") == "toggles") {
                    $(".krown-tabs").each(function() {
                        var $titles = $(this)
                                .children(".titles")
                                .children("h5"),
                            $contents = $(this)
                                .find(".contents")
                                .children("div"),
                            i = 0;

                        $titles.each(function() {
                            $contents.eq(i++).insertAfter($(this));

                            $(this).on("click", function() {
                                var $toggle = $(this).next(".tab");

                                if (!$(this).hasClass("opened")) {
                                    $(this).addClass("opened");
                                    $toggle.stop().slideDown(200);
                                } else {
                                    $(this).removeClass("opened");
                                    $toggle.stop().slideUp(200);
                                }
                            });
                        });

                        $(this)
                            .find(".contents")
                            .remove();
                    });
                } else {
                    $(".krown-tabs").each(function() {
                        var $titles = $(this)
                                .children(".titles")
                                .children("h5"),
                            $contents = $(this)
                                .children(".contents")
                                .children("div"),
                            $openedT = $titles.eq(0),
                            $openedC = $contents.eq(0);

                        $openedT.addClass("opened");
                        $openedC.stop().slideDown(0);

                        $titles
                            .find("a")
                            .prop("href", "#")
                            .off("click");

                        $titles.click(function(e) {
                            $openedT.removeClass("opened");
                            $openedT = $(this);
                            $openedT.addClass("opened");

                            $openedC.stop().slideUp(200);
                            $openedC = $contents.eq($(this).index());
                            $openedC
                                .stop()
                                .delay(200)
                                .slideDown(200);

                            e.preventDefault();
                        });
                    });
                }

                if ($(".site-footer .info").length > 0) {
                    if (
                        $(".site-footer .info")
                            .html()
                            .split("").length > 18
                    ) {
                        $(".site-footer .info").addClass("smaller");
                    }
                }
            },

            unmount: function() {
                $(window).off("scroll.scroll-movers");
            }
        },

        Contact: {
            mount: function($elm) {
                if ($elm.find(".contact-map-holder").length > 0) {
                    if (
                        $elm.find(".contact-map-object").data("address") != ""
                    ) {
                        if (typeof google !== "undefined") {
                            this._createMap(
                                $elm.attr("id"),
                                $elm.find(".contact-map-object"),
                                $elm.find(".contact-map-address-holder")
                            );
                        } else {
                            if (window.loadingGoogleMapsScript) {
                                $elm.ti = setInterval(
                                    function($elm) {
                                        if (typeof google !== "undefined") {
                                            clearInterval($elm.ti);
                                            this._createMap(
                                                $elm.attr("id"),
                                                $elm.find(
                                                    ".contact-map-object"
                                                ),
                                                $elm.find(
                                                    ".contact-map-address-holder"
                                                )
                                            );
                                        }
                                    }.bind(this, $elm),
                                    100
                                );
                            } else {
                                window.loadingGoogleMapsScript = true;
                                $.getScript(
                                    "https://maps.googleapis.com/maps/api/js?v=3&key=" +
                                        $elm
                                            .find(".contact-map-holder")
                                            .data("key")
                                ).done(
                                    function() {
                                        this._createMap(
                                            $elm.attr("id"),
                                            $elm.find(".contact-map-object"),
                                            $elm.find(
                                                ".contact-map-address-holder"
                                            )
                                        );
                                    }.bind(this)
                                );
                            }
                        }
                    }
                }
            },

            _createMap: function(id, $mapInsert, $mapAddress) {
                $mapInsert.attr("id", "contact-map-" + id);

                var coordsKey = "map-coords-" + $mapInsert.attr("id"),
                    coordsStorage =
                        localStorage.getItem(coordsKey) != null
                            ? JSON.parse(localStorage.getItem(coordsKey))
                            : null,
                    mapLat = 0,
                    mapLong = 0;

                if (
                    coordsStorage != null &&
                    coordsStorage["address"] == $mapInsert.data("address")
                ) {
                    mapLat = coordsStorage["lat"];
                    mapLong = coordsStorage["long"];
                }

                var geocoder, map, address;

                geocoder = new google.maps.Geocoder();
                address = $mapInsert.data("address");

                var mapOptions = {
                    zoom: $mapInsert.data("zoom"),
                    center: new google.maps.LatLng(mapLat, mapLong),
                    streetViewControl: false,
                    scrollwheel: true,
                    panControl: false,
                    mapTypeControl: false,
                    overviewMapControl: false,
                    zoomControl: false,
                    draggable: true,
                    styles:
                        $mapInsert.data("style") == "light"
                            ? window.lightMapStyle
                            : window.darkMapStyle
                };

                map = new google.maps.Map(
                    document.getElementById($mapInsert.attr("id")),
                    mapOptions
                );

                if (mapLat != 0 || mapLong != 0) {
                    var markerOptions = {
                        position: new google.maps.LatLng(mapLat, mapLong),
                        map: map,
                        title: address
                    };

                    if ($mapInsert.data("marker") != "none") {
                        markerOptions["icon"] = {
                            url: $mapInsert.data("marker"),
                            scaledSize: new google.maps.Size(60, 60)
                        };
                    }

                    $mapAddress
                        .find("a")
                        .attr(
                            "href",
                            "http://www.google.com/maps/place/" +
                                mapLat +
                                "," +
                                mapLong
                        );
                    var contentString = $mapAddress.html();
                    var infowindow = new google.maps.InfoWindow({
                        content: contentString
                    });

                    var marker = new google.maps.Marker(markerOptions);
                    marker.addListener("click", function() {
                        infowindow.open(map, marker);
                        if ($(window).width() < 480) {
                            $(
                                ".template-page-contact .box__heading .title"
                            ).css("marginTop", 50);
                        } else if ($(window).width() < 768) {
                            $(
                                ".template-page-contact .box__heading .title"
                            ).css("marginTop", 100);
                        }
                    });

                    if ($(window).width() > 768) {
                        map.panBy(-150, 150);
                    } else {
                        map.panBy(-75, 75);
                    }
                } else {
                    if (geocoder) {
                        geocoder.geocode({ address: address }, function(
                            results,
                            status
                        ) {
                            if (status == google.maps.GeocoderStatus.OK) {
                                if (
                                    status !=
                                    google.maps.GeocoderStatus.ZERO_RESULTS
                                ) {
                                    map.setCenter(results[0].geometry.location);

                                    var markerOptions = {
                                        position: results[0].geometry.location,
                                        map: map,
                                        title: address
                                    };

                                    if ($mapInsert.data("marker") != "none") {
                                        markerOptions["icon"] = {
                                            url: $mapInsert.data("marker"),
                                            scaledSize: new google.maps.Size(
                                                60,
                                                60
                                            )
                                        };
                                    }

                                    $mapAddress
                                        .find("a")
                                        .attr(
                                            "href",
                                            "http://www.google.com/maps/place/" +
                                                results[0].geometry.location.lat() +
                                                "," +
                                                results[0].geometry.location.lng()
                                        );
                                    var contentString = $mapAddress.html();
                                    var infowindow = new google.maps.InfoWindow(
                                        {
                                            content: contentString
                                        }
                                    );

                                    var marker = new google.maps.Marker(
                                        markerOptions
                                    );
                                    marker.addListener("click", function() {
                                        infowindow.open(map, marker);
                                    });

                                    if ($(window).width() > 768) {
                                        map.panBy(-150, 150);
                                    } else {
                                        map.panBy(-75, 75);
                                    }

                                    localStorage.setItem(
                                        coordsKey,
                                        JSON.stringify({
                                            address: $mapInsert.data("address"),
                                            lat: results[0].geometry.location.lat(),
                                            long: results[0].geometry.location.lng()
                                        })
                                    );
                                } else {
                                    alert(
                                        "No results found for the given address"
                                    );
                                }
                            } else {
                                console.log(
                                    "Geocode was not successful for the following reason: " +
                                        status
                                );
                            }
                        });
                    }
                }
            },

            unmount: function() {}
        },

        // SCROLL EFFECT
        Scroll: {
            $headerSize:70,
            $mount: false,
            $clip:[1000000,0],
            $range:0,
            $clipHeight:0,
            $clipWidth:0,


            handleScroll: function(){
                $(document).on("scroll",function(){
                    var haveScroll = $(document).scrollTop() > 30;
                    if(haveScroll) $('body').addClass("have-scroll");
                    else $('body').removeClass("have-scroll");
                });
            },

            mount: function() {
                $(window).resize(function(){
                   this.check();
                }.bind(this));
                this.check();
            },

            /* Animazione presente solo in desktop */
            check: function(){
                if($(window).width()<768) this.remove();
                else this.init();
            },

            /* Calcola dimensione clip */
            calcolateSize: function(){
                this.$clipHeight = $('.fixedscroll').height();
                this.$clipWidth  = $('.fixedscroll').width();
                let clip = [1000000,0];
                 // Aggiungo wrap agli elementi
                 $('.fixedscroll').each(function(){
                    let itm = $(this);
                    if(clip[0] > itm.offset().top){
                        clip[0]=itm.offset().top;
                    }
                    if(clip[1]<itm.offset().top){
                        clip[1]=itm.offset().top;
                    }
                });
                this.$clip  = clip;
                this.$range = this.$clip[1]-this.$clip[0];
                this.onscroll();
            },

            /* Init animazione */
            init: function(){
                this.calcolateSize();
                if(this.$mount) return;
                this.$mount = true;

                // Aggiungo wrap agli elementi
                $('.fixedscroll').each(function(){
                    $(this).children().wrap("<div class='scrollhandle'></div>");
                });

                // handle scroll
                $(document).on("scroll",function(){
                    this.onscroll();
                }.bind(this));
            },
            /* Anima gli elementi allo scroll della pagina */
            onscroll: function(){
                if(!this.$mount) return;
                let top = $(window).scrollTop()+this.$headerSize;
                if(top<this.$clip[0] || top > this.$clip[1]){
                    // remove style
                    $('.fixedscroll').removeClass('fixed');
                    $('.scrollhandle').attr('style','');
                    return;
                }
                $('.fixedscroll').addClass("fixed");
                top-= this.$clip[0];
                // elemento corrente da visualizzare
                let current = Math.ceil(top / this.$clipHeight);
                let i = 0;
                let ctx = this;
                $('.scrollhandle').each(function(){
                    let itm = $(this);
                    let clipHeight = ctx.$clipHeight;
                    if(i>current)  clipHeight = 0;
                    if(i==current) clipHeight = top % clipHeight;
                    // crea maschera
                    itm.attr('style','clip:rect(0px, '+ctx.$clipWidth+'px, '+clipHeight+'px, 0px)');
                    i++;
                });
            },

            remove: function() {
                if(this.$mount){
                    this.$mount = false;
                    $('.fixedscroll').removeClass('fixed');
                    $('.scrollhandle').each(function(){
                        var itm = $(this).parent();
                        itm.append($(this).children());
                        itm.find('.scrollhandle').remove();
                    });
                }
            }
        },

        // IMAGES

        Images: {
            boxImages: [],

            mount: function() {
                this.boxImages = [];

                if ($(".box--product-image").length > 0) {
                    $(".box--product-image:not(.on)").each(
                        function(key, elm) {
                            $(elm).addClass("on");
                            this.boxImages.push({
                                $elm: $(elm),
                                img: $(elm).children("img")[0],
                                srcset: $(elm)
                                    .children("img")
                                    .data("srcset")
                            });
                        }.bind(this)
                    );
                }

                $(window)
                    .on(
                        "resize.box-images",
                        function() {
                            this.boxImages.forEach(function(entry) {
                                var desiredDensity =
                                        window.devicePixelRatio <= 2
                                            ? window.devicePixelRatio
                                            : 2,
                                    desiredSize =
                                        entry["$elm"].width() * desiredDensity;

                                if (entry["img"].naturalWidth > 0) {
                                    if (
                                        entry["$elm"].width() /
                                            entry["$elm"].height() <
                                        entry["img"].naturalWidth /
                                            entry["img"].naturalHeight
                                    ) {
                                        var desiredHeight = Math.ceil(
                                            entry["$elm"].height() *
                                                desiredDensity
                                        );
                                        desiredSize =
                                            (desiredHeight *
                                                entry["img"].naturalWidth) /
                                            entry["img"].naturalHeight;
                                    }
                                }

                                if (desiredSize <= 480) {
                                    entry["$elm"].css(
                                        "backgroundImage",
                                        "url(" + entry["srcset"].small + ")"
                                    );
                                } else if (desiredSize <= 960) {
                                    entry["$elm"].css(
                                        "backgroundImage",
                                        "url(" + entry["srcset"].medium + ")"
                                    );
                                } else if (desiredSize <= 1440) {
                                    entry["$elm"].css(
                                        "backgroundImage",
                                        "url(" + entry["srcset"].large + ")"
                                    );
                                } else if (desiredSize > 1440) {
                                    entry["$elm"].css(
                                        "backgroundImage",
                                        "url(" + entry["srcset"].huge + ")"
                                    );
                                }
                            });
                        }.bind(this)
                    )
                    .trigger("resize.box-images");
            },

            unmount: function() {
                $(window).off("resize.box-images");
            }
        },

        Popup: {
            $popup: null,

            mount: function() {
                this.$popup = $("#shopify-section-popup");

                var show = this.$popup.find(".popup-content").data("show"),
                    freq = this.$popup.find(".popup-content").data("freq"),
                    enable = this.$popup.find(".popup-content").data("enable");

                if (show > 0 && enable) {
                    setTimeout(
                        function() {
                            this._trigger(show, freq);
                        }.bind(this),
                        parseInt(show * 1000)
                    );
                }

                this.$popup.find(".site-close-handle").on(
                    "click",
                    function(e) {
                        this._hide();
                    }.bind(this)
                );

                this.$popup.find(".popup-background").on(
                    "click",
                    function(e) {
                        this._hide();
                    }.bind(this)
                );
            },

            _show: function() {
                this.$popup.addClass("active");
            },

            _hide: function() {
                this.$popup.removeClass("active");
            },

            _trigger: function(show, freq) {
                var popupKey = "popup-" + document.location.hostname,
                    popupStorage = localStorage.getItem(popupKey) != null
                            ? JSON.parse(localStorage.getItem(popupKey))
                            : null;

                if (popupStorage != null) {
                    if (
                        popupStorage["show"] != show ||
                        popupStorage["freq"] != freq
                    ) {
                        this._refreshStorage(popupKey, show, freq);

                        // user saw the ad but settings are different - show it!
                        this._show();
                    } else {
                        // user saw the ad so we need to check if he should see it again

                        if (freq == "every") {
                            if (
                                sessionStorage[popupKey] == null ||
                                sessionStorage[popupKey] != "shown"
                            ) {
                                this._show();
                                this._refreshStorage(popupKey, show, freq);
                            }
                        } else {
                            var shownAt = popupStorage["shown"],
                                nowAt = new Date().getTime(),
                                inBetween = Math.round(
                                    (nowAt - shownAt) / 1000
                                );

                            if (freq == "day" && inBetween > 129600) {
                                this._show();
                                this._refreshStorage(popupKey, show, freq);
                            } else if (freq == "week" && inBetween > 907200) {
                                this._show();
                                this._refreshStorage(popupKey, show, freq);
                            }
                        }
                    }
                } else {
                    this._refreshStorage(popupKey, show, freq);

                    // user never saw the ad - show it!

                    this._show();
                }
            },

            _refreshStorage: function(popupKey, show, freq) {
                localStorage.setItem(
                    popupKey,
                    JSON.stringify({
                        show: show,
                        freq: freq,
                        shown: new Date().getTime()
                    })
                );

                sessionStorage[popupKey] = "shown";
            },

            unmount: function() {}
        },

        // SOCIAL

        Social: {

            mount:function(){
                $('.social-link').on("click",function(){
                    var url = $(this).attr('href');
                    var width = $(window).width();
                    if(width>400) width=400;
                    window.open(url,"Share","toolbar=no,titlebar=no,width="+width+",height=300");
                    return false;
                });
            }
        },

        Collection:{
            autocomplete:null,
            input:null,
            current:"",
            show:false,
            tag_prefix:"",
            max:10,

            mount: function(){
                // Init value
                this.autocomplete = $('.searchbar .autocomplete');
                this.input = $('#filterinput');
                this.tag_prefix = this.input.attr('data-tag-prefix');
                this.max    = parseInt(this.input.attr('data-max'));
                if(this.max<=0) this.max = 10;

                // Click outside search (close autocomplete and search)
                $(window).click(function() {
                    if(this.show){
                        this.hideAutoComplete(true);
                    }
                }.bind(this));

                // Click inside search stop
                this.input.click(function(e){
                    e.stopPropagation();
                  $(".select-structure").hide();
                });

                // User write text
                this.input.keyup(function(){
                    this.search(this.input.val());
                }.bind(this));
            },


            /**
             * Filtra la lista prodotti in base al tag
             * inserito dall'utente
             */
            filterProduct:function(){
                if(this.current==""){
                    $('.filterable').removeClass("hide");
                }
                else{
                    var search = (this.tag_prefix+this.current).toLowerCase();
                    $('.filterable').each(function(){
                        var self = $(this);
                        var id = self.attr('data-id');
                        var tags = window.osproducts[id] ? window.osproducts[id]:[];
                        var found = false;
                        for(var i=0;i<tags.length;i++){
                            if(tags[i].toLowerCase()==search){
                                found=true;
                                break;
                            }
                        }
                        if(found) self.removeClass("hide");
                        else self.addClass("hide");
                    });
                }
            },

            hideAutoComplete:function(clear){
                this.show = false;
                this.autocomplete.html("");
                this.autocomplete.removeClass("show");
                if(clear){
                    this.input.val("");
                    this.current="";
                }
                this.filterProduct();
            },

            showAutocomplete:function(list){
                if(list.length==0){
                    this.hideAutoComplete(false);
                }else{
                    this.show = true;
                    var self = this;
                    var h="";
                    $.each(list,function(i,v){
                        if(i<this.max){
                            h+="<a href='#' data-handle='"+v.handle+"'>"+v.name+"</a>";
                        }
                    }.bind(this));
                    this.autocomplete.html(h);
                    this.autocomplete.addClass("show");
                    this.autocomplete.find('a').on("click",function(e){
                        e.stopPropagation();
                        self.current = $(this).attr('data-handle');
                        self.input.val($(this).html());
                        self.hideAutoComplete(false);
                        return false;
                    });
                }
            },

            search: function(value){
                var searchValue = value.toLowerCase();
                if(searchValue==""){
                    this.showAutocomplete([]);
                    return;
                }
                var list = [];
                $.each(search_handles,function(index,itm){
                    if(itm.name.indexOf(searchValue)>=0){
                        list.push(itm);
                    }
                });
                this.showAutocomplete(list);
            }
        },

        SvgKit:{
            mount: function(){
                let dom = $('#svgkit');
                let svg = dom.find('svg');
                // Elemento selezionato

                if(dom.attr('data-selected')!==""){
                    let idSel = "#"+dom.attr('data-selected');
                    $(idSel).attr("class","room current");
                    svg.append($(idSel));
                }else{
                    dom.addClass("no-selection");
                }

                // Mouse hover
                svg.find('.room').on("mouseenter",function(){
                    svg.append($(this));
                });
                svg.find('.room').on("mouseleave",function(){
                    if(svg.find('.room.current').length>0){
                        svg.append(svg.find('.room.current'));
                    }
                });
                // Click
                svg.find('.room').on("click",function(){
                   let id = $(this).attr('id');
                   if(window.kitlink[id]!==undefined){
                       window.location = window.kitlink[id];
                   }
                });
            }
        },

        Newsletter:{
            mount: function(){
                var self = this;
                $('.newsletter-widget').each(function(){
                    self.init($(this));
                });
            },
            isEmail: function(email) {
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            showError: function(itm,element){
                var cl = element.attr('data-error');
                if(cl){
                    itm.find('.'+cl).css("display","block");
                }
            },
            check: function(itm){
                itm.find('.error').css("display","none");
                var mail = itm.find('input.email').val();
                if(!this.isEmail(mail)){
                    this.showError(itm,itm.find('input.email'));
                    return false;
                }
                if(!itm.find('.check').is(":checked")){
                    this.showError(itm,itm.find('input.check'));
                   return false;
                 }
                return true;
            },
            init: function(itm){
                var self = this;
                itm.find('input.submit').click(function(){
                    return self.check(itm);
                });
            }
        },

        Privacy:{
            check:function(){
                var wrp = $('.check-privacy-wrap');
                if(wrp.find('.check').prop('checked'))
                    return true;
                wrp.find('.error').css('display','block');
                return false;
            },
            mount:function(){
                $(".check-privacy-input").on("click",function(){
                    return this.check();
                }.bind(this));
            }
        },

        Checkbox:{
            init: function(itm){
                itm.wrap("<div class='os-checkbox-wrp'></div>");
                itm.css('display','none');
                let dom  = itm.parent();
                dom.append('<span></span>');

                dom.on("click",function(){
                    dom.toggleClass("checked");
                    itm.prop("checked",dom.hasClass("checked"));
                });
            },
            mount:function(){
                var self = this;
                $('.os-checkbox').each(function(){
                    self.init($(this));
                });
            }
        },

        Preview3d:{
            mount: function(){
                $(".cms-box-3d").each(function(){
                    var $self = $(this);
                    var $preview = $self.find('.preview');
                    $self.find('a.show3d').on("click",function(){
                        $preview.hide();
                        return false;
                    });
                    $self.find('a.hide3d').on("click",function(){
                        $preview.show();
                        return false;
                    });
                });
            }
        }

    };

    $(document).on("ready", function() {
        window.CUBER.Main.mount();
        window.CUBER.Newsletter.mount();
        window.CUBER.Checkbox.mount();
        window.CUBER.Social.mount();
        window.CUBER.Scroll.handleScroll();
        window.CUBER.SiteCart.mount();
        window.CUBER.Popup.mount();

        /*if($('.fixedscroll').length > 0){
            window.CUBER.Scroll.mount();
        }*/

        if($('#cartview').length>0){
            $('#cartview .cart-item').each(function(){
                window.CUBER.SiteCart.handleEvent($(this));
            })
        }

        if($('.cms-box-3d').length>0){
            window.CUBER.Preview3d.mount();
        }

        if($(".check-privacy-input").length>0){
            window.CUBER.Privacy.mount();
        }

        // Popup Form prodotti fine pagina se presenti
        if ($(".popup-product-cart").length > 0) {
            window.CUBER.PopupProduct.mount();
        }

        if($('#svgkit').length>0){
            window.CUBER.SvgKit.mount();
        }

        if($("#cartview").length>0){
            window.CUBER.PageCart.mount();
        }

        if ($(".product-page").length > 0) {
            window.CUBER.Product.centerStructure();
            $(".product-page").each(function() {
                window.CUBER.Product.mount($(this));
            });
        }

        if($('#mobile-slider').length>0){
           window.CUBER.Gallery.mount();
        }

        $('.styled-select').styledSelect();



        if($('#filterinput').length > 0){
            window.CUBER.Collection.mount();
        }

        if (
            $("body").hasClass("template-page-contact") ||
            ($("body").hasClass("template-index") && $(".mount-map").length > 0)
        ) {
            $(".mount-map").each(function() {
                window.CUBER.Contact.mount($(this));
            });
        }

        // Section evente
        // select

        $(document).on("shopify:section:select", function(e) {
            var $section = $(e.target);

            if ($section.hasClass("mount-header")) {
                if (
                    $section.find("#site-header").hasClass("style--sidebar") ||
                    $section.find("#site-header").hasClass("style--fullscreen")
                ) {
                    if (!$section.find("#site-nav").hasClass("active")) {
                        $("#site-menu-handle a").trigger("click");
                    }
                }
            }

            if (
                $("#site-header").hasClass("desktop-view--minimal") &&
                $("#fix-me-header").css("display") == "none"
            ) {
                setTimeout(function() {
                    $("html, body")
                        .stop()
                        .animate({ scrollTop: $section.offset().top }, 0);
                }, 400);
            }

            if ($section.hasClass("mount-popup")) {
                window.CUBER.Popup._show();
            }
        });

        // deselect

        $(document).on("shopify:section:deselect", function(e) {
            var $section = $(e.target);

            if ($section.hasClass("mount-header")) {
                if (
                    $section.find("#site-header").hasClass("style--sidebar") ||
                    $section.find("#site-header").hasClass("style--fullscreen")
                ) {
                    if ($section.find("#site-nav").hasClass("active")) {
                        $("#site-menu-handle a").trigger("click");
                    }
                }
            }

            if ($section.hasClass("mount-popup")) {
                window.CUBER.Popup._hide();
            }
        });

        // load

        $(document).on("shopify:section:load", function(e) {
            var $section = $(e.target);

            if ($section.hasClass("mount-header")) {
                window.CUBER.Nav.mount();
            }
            if ($section.hasClass("mount-images")) {
                //window.CUBER.Images.mount();
            }




            if ($section.hasClass("mount-product")) {
                window.CUBER.Product.mount($section);
            }
            if ($section.hasClass("mount-map")) {
                window.CUBER.Contact.mount($section);
            }

            if ($section.hasClass("mount-popup")) {
                window.CUBER.Popup.mount();
            }

            window.CUBER.Main.mount();
            //window.CUBER.Scroll.mount();
        });

        // unload

        $(document).on("shopify:section:unload", function(e) {
            var $section = $(e.target);

            if ($section.hasClass("mount-header")) {
                window.CUBER.Nav.unmount();
            }
            if ($section.hasClass("mount-images")) {
                window.CUBER.Images.unmount();
            }



            if ($section.hasClass("mount-product")) {
                window.CUBER.Product.unmount($section);
            }
            if ($section.hasClass("mount-map")) {
                window.CUBER.Contact.unmount();
            }

            window.CUBER.Main.unmount();
            window.CUBER.Scroll.unmount();
        });

        // blocks

        $(document).on("shopify:block:select", function(e) {
            var $block = $(e.target);
            if ($block.hasClass("slideshow-item")) {
                if ($(".responsive-flickity").hasClass("flickity-enabled")) {
                    $(".responsive-flickity")
                        .data("flickity")
                        .select($block.index());
                } else {
                    $(window).scrollTop($block.offset().top);
                }
                $block
                    .find(".caption, .title, .subtitle")
                    .css("transform", "translateY(0)");
            }
        });



        $(".simple-grid select:not(.styled)").each(function() {
            $(this)
                .styledSelect({
                    coverClass: "regular-select-cover",
                    innerClass: "regular-select-inner"
                })
                .addClass("styled");
            $(this)
                .parent()
                .append($.themeAssets.arrowDown);
        });

        if ($("body").hasClass("template-customers-login")) {
            if ($("#RecoverPassword").length > 0) {
                $("#RecoverPassword").on("click", function(e) {
                    $("#CustomerLoginForm").hide();
                    $("#RecoverPasswordForm").show();
                    $("#LoginRecoverTitle").html(
                        $("#LoginRecoverTitle").data("password_recovery")
                    );
                    e.preventDefault();
                });

                $("#HideRecoverPasswordLink").on("click", function(e) {
                    $("#RecoverPasswordForm").hide();
                    $("#CustomerLoginForm").show();
                    $("#LoginRecoverTitle").html(
                        $("#LoginRecoverTitle").data("login")
                    );
                    e.preventDefault();
                });

                if (window.location.hash == "#recover") {
                    $("#RecoverPassword").trigger("click");
                }
            }
        } else if ($("body").hasClass("template-customers-addresses")) {

        }

        //

        if (
            $("body").hasClass("template-blog") ||
            $("body").hasClass("template-article")
        ) {
            window.CUBER.Main._mountScrollMovers({
                parent: $(".scroll-movers-parent"),
                items: $(".site-sharing")
            });

            window.CUBER.Main._mobileSharingInit();
        }
    });
})(jQuery);

function response(data) {
    console.log(data);
}

window._getLuminance = function(hexy) {
    var rgb = this._toRgb(hexy);
    return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
};

window._toRgb = function(hexy) {
    var hex = hexy.replace("rgb(", "");
    hex = hex.replace(")", "");
    hex = hex.replace(" ", "");
    hex = hex.replace(" ", "");
    hex = hex.split(",");
    return { r: hex[0], g: hex[1], b: hex[2] };
};

$(window).on("load", function() {
    setTimeout(function() {
        if (
            $("body").attr("id") == "challenge" ||
            location.pathname == "/challenge"
        ) {
            document.location.hash = "challenge";
            $("html, body").scrollTop(0);
        }
    }, 150);
});


//autoscroll al clcik dello user
//do autoscroll when user click botton
$(window).load(function () {
    $('#scroll-element-click').click(function (event) {
        event.preventDefault();
         var Mobile = window.matchMedia("only screen and (max-width:970px)").matches;
      if (Mobile) {
        $('#scroll-element-click').scrollView();
      }
      else {
        $('#jquery-scroll-here').scrollView();
      }

    });
});
$.fn.scrollView = function () {
    return this.each(function () {
        $('html, body').animate({
            scrollTop: $(this).offset().top
        }, 1000);
    });
}



 //display select by user arrow click
$('.arrow_select').click(function () {
    $('.select-structure').toggle();
});


//hide select when user click outiside
$(document).mouseup(function(e)
{
    var select_structure = $(".select-structure");

    // if the target of the click isn't the container nor a descendant of the container
    if (!select_structure.is(e.target) && select_structure.has(e.target).length === 0)
    {
        select_structure.hide();
    }

});



//give element of select to input
$(".select-structure").change(function () {
    $('.select-structure').hide();
    $('#filterinput').val($(this).val());

    var h = $('#filterinput').val();
    //  console.log("CONTENUTO:", h);


});


var fiscalCodeUpper = function () {

        var fiscal_code_textbox = document.querySelector(".cart-info .wrapfiscalcode input.codfiscale");

        if (fiscal_code_textbox !== null) {


            fiscal_code_textbox.addEventListener('keyup', function() {
                this.value = this.value.toLocaleUpperCase();
            });
        }
}


fiscalCodeUpper();

// Accordion by WebSensePro.com
$(function() {
	// (Optional) Active an item if it has the class "is-active"	
	$(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
	
	$(".accordion > .accordion-item").click(function() {
		// Cancel the siblings
		$(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
		// Toggle the item
		$(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
	});
});

$(function() {
	// (Optional) Active an item if it has the class "is-active"	
	$(".accordion > .accordion-item.is-active").children(".accordion-panel2").slideDown();
	
	$(".accordion > .accordion-item").click(function() {
		// Cancel the siblings
		$(this).siblings(".accordion-item2").removeClass("is-active").children(".accordion-panel2").slideUp();
		// Toggle the item
		$(this).toggleClass("is-active").children(".accordion-panel2").slideToggle("ease-out");
	});
});











